module.exports = __webpack_public_path__ + "0.index.worker.js"